module.exports = __webpack_public_path__ + "static/img/5.07b08f0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/9/zh/5.png
// module id = rjQ+
// module chunks = 0